<template>
    <div class="answers-page-customers">
        <answersList :listData="questionsPage.q_buyers" v-if="!isMobileChecker"></answersList>
        <answersListMobile :listData="questionsPage.q_buyers" v-else></answersListMobile>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    // import svgIcon from '@/components/partials/SvgIcon.vue';
    import answersList from '@/components/answers-page/answers-list.vue';
    import answersListMobile from '@/components/answers-page/answers-list-mobile.vue';
    export default {
        name: 'answers-customers',
        components: {
            answersList,
            answersListMobile,
            // svgIcon,
        },
        data () {
            return {
            }
        },
        computed: mapGetters({
            questionsPage: 'loadQuestionsPage',
            isMobileChecker: 'loadIsMobileChecker',
        }),
        methods: {
        },
        beforeCreate() {
        },
        created () {
        },
        mounted() {
        }
    }
</script>

<style lang="scss">
    // @import '@/styles/components/about-page/awards-section.scss';
    // @import '@/styles/components/about-page/respond/awards-section-respond.scss';
</style>